import Marquee from "react-fast-marquee";
import { useI18n } from "../../i18n/LanguageContext";

export const BrandMarquee = () => {
  const { t, lang } = useI18n();
  return (
    <section className="py-10 border-y border-white/5 bg-[#0a0e14]/40" data-testid="brand-marquee">
      <Marquee key={lang} speed={45} gradient={false} autoFill>
        {t.marquee.map((tItem, i) => (
          <div key={i} className="flex items-center">
            <span className="font-display font-extrabold text-3xl md:text-5xl px-8 text-transparent [-webkit-text-stroke:1px_rgba(255,255,255,0.16)]">
              {tItem}
            </span>
            <span className="h-2 w-2 rounded-full bg-cyan-400/70" />
          </div>
        ))}
      </Marquee>
    </section>
  );
};
